import type { TranslationMessages } from '../types';

export const costs: TranslationMessages = {
  title: 'Chi phí',
  name: 'Quản lý Chi phí',
  create_cost: 'Thêm Chi phí',
  subtitle: 'Theo dõi và quản lý chi phí kinh doanh',
  versions: {
    modern: 'Quản lý Chi phí Hiện đại',
  },
  stats: {
    total_costs: 'Tổng Chi phí',
    entries: 'mục',
    this_month: 'Tháng này',
    current_month_expenses: 'Chi phí tháng hiện tại',
    categories: 'Danh mục',
    active_categories: 'Danh mục hoạt động',
    average_cost: 'Chi phí Trung bình',
    per_entry: 'Mỗi mục',
  },
  search_placeholder: 'Tìm kiếm chi phí...',
  all_categories: 'Tất cả Danh mục',
  no_costs_found: 'Không tìm thấy chi phí',
  try_adjusting_filters: 'Thử điều chỉnh tiêu chí tìm kiếm hoặc bộ lọc của bạn',
  add_first_cost: 'Thêm Chi phí Đầu tiên',
  no_permission_edit: 'Bạn không có quyền chỉnh sửa mục chi phí.',
  fields: {
    description: 'Mô tả',
    amount: 'Số tiền',
    category: 'Danh mục',
    method: 'Phương thức Thanh toán',
    date: 'Ngày',
    notes: 'Ghi chú',
    payment_method: 'Phương thức Thanh toán',
  },
  unknown: 'Không xác định',
  messages: {
    costCreated: 'Tạo mục chi phí thành công',
    costUpdated: 'Cập nhật mục chi phí thành công',
    costDeleted: 'Xóa mục chi phí thành công',
  },
  create: {
    title: 'Tạo Mục Chi phí',
    subtitle: 'Thêm một khoản chi phí mới để theo dõi',
    no_permission: 'Bạn không có quyền tạo mục chi phí.',
    basic_information: 'Thông tin Cơ bản',
    description_placeholder: 'Nhập mô tả chi phí...',
    description_required: 'Mô tả là bắt buộc',
    amount_placeholder: '0.00',
    amount_required: 'Số tiền là bắt buộc',
    amount_positive: 'Số tiền phải là số dương',
    date_required: 'Ngày là bắt buộc',
    category_payment: 'Danh mục & Thanh toán',
    select_category: 'Chọn danh mục',
    search_categories: 'Tìm kiếm danh mục...',
    no_category_found: 'Không tìm thấy danh mục.',
    category_required: 'Danh mục là bắt buộc',
    payment_method_placeholder: 'Chọn phương thức thanh toán',
    payment_method_none: 'Không có',
    payment_method_cash: 'Tiền mặt',
    payment_method_bank: 'Chuyển khoản Ngân hàng',
    payment_method_credit_card: 'Thẻ Tín dụng',
    payment_method_vnpay: 'VnPay',
    payment_method_momo: 'MoMo',
    payment_method_zalopay: 'ZaloPay',
    payment_method_other: 'Khác',
    receipt: 'Hóa đơn',
    receipt_preview: 'Xem trước hóa đơn',
    upload_receipt: 'Tải lên Hóa đơn',
    capture_receipt: 'Chụp Hóa đơn',
    capture_button: 'Chụp',
    camera_instructions:
      'Đặt hóa đơn trước camera và nhấp Chụp khi sẵn sàng',
    loading_camera: 'Đang tải camera...',
    uploading_receipt: 'Đang tải lên...',
    receipt_description:
      'Tải lên hoặc chụp ảnh hóa đơn (tùy chọn)',
    additional_notes: 'Ghi chú Bổ sung',
    notes_placeholder: 'Thêm bất kỳ ghi chú hoặc chi tiết bổ sung...',
    summary: 'Tóm tắt',
    not_selected: 'Chưa chọn',
    save_button: 'Lưu Mục Chi phí',
  },
};
